export default "__VITE_ASSET__88a26f5a__"